// CBC Senior School (G10–G12) pathways — mirrors backend/utils/pathways.js.
// Kept as a static list to avoid a round-trip; the backend exposes the same
// values at GET /api/academics/pathways if a dynamic source is ever needed.

// The pathways a learner can be placed in.
export const LEARNER_PATHWAYS = ['STEM', 'Social Sciences', 'Arts & Sports Science'];

// 'Common' = every learner in the stage takes it regardless of pathway.
export const COMMON = 'Common';
export const SUBJECT_PATHWAYS = [COMMON, ...LEARNER_PATHWAYS];

// Does a subject tagged `subjectPathway` apply to a learner on `learnerPathway`?
// Common (or blank, for legacy rows) applies to everyone.
export const subjectAppliesToPathway = (subjectPathway, learnerPathway) => {
  const sp = subjectPathway || COMMON;
  if (sp === COMMON) return true;
  return sp === (learnerPathway || '');
};
